import React from 'react';
import {
  NewNodeLunchContent,
  ThemeModeTooltipContent,
} from './spotlight-tooltip-content';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'typesafe-actions';
import { CallBackProps, STATUS } from 'react-joyride';
import { setThemeSpotlightVisited } from '../../redux/feature-spotlights';
import { useMatchMedia } from '@make-software/cspr-ui';

const SPOTLIGHT_Z_INDEX = 10000;

interface SpotlightContent {
  target: string;
  content: React.ReactNode;
  offset?: number;
  placement?: 'top' | 'bottom' | 'left' | 'right' | 'center';
  width?: string;
  showSalute?: boolean;
}

type SpotlightContentByKey = Record<string, SpotlightContent>;

const spotlightContentByKey: SpotlightContentByKey = {
  theme: {
    target: '.dark-theme-spotlight-target',
    content: <ThemeModeTooltipContent />,
  },
  nodeLunch: {
    target: '.new-node-lunch-spotlight-target',
    content: <NewNodeLunchContent />,
    placement: 'center',
    width: '376px',
    showSalute: true,
  },
};

const spotlightContentDefaultOptions = {
  disableBeacon: true,
  spotlightPadding: 0,
  spotlightClicks: true,
  placement: 'bottom-end',
  styles: {
    options: {
      zIndex: SPOTLIGHT_Z_INDEX,
    },
  },
  floaterProps: {
    hideArrow: true,
    disableAnimation: true,
  },
  arrowColor: 'transparent',
};

export const useSpotlight = () => {
  const dispatch = useDispatch();
  const [stepIndex, setStepIndex] = React.useState(0);
  const featureSpotlights = useSelector(
    (state: RootState) => state.featureSpotlights
  );
  const shouldDeactivateOnMobile = useMatchMedia(
    [false, false, true, true],
    []
  );

  const deactivateSpotlights = () => dispatch(setThemeSpotlightVisited(true));

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status, index } = data;

    if (
      [STATUS.FINISHED, STATUS.SKIPPED].includes(status) &&
      shouldDeactivateOnMobile
    ) {
      deactivateSpotlights();
    } else {
      setStepIndex(index);
    }
  };

  const unwatchedSpotlights = Object.entries(featureSpotlights)
    .filter(([, value]) => !value.expired)
    .filter(([, value]) => !value.visited)
    .filter(([, value]) => !value.ignored);

  const runAllSpotlights = unwatchedSpotlights.length > 0;

  const steps = unwatchedSpotlights.map(([key, value]) => {
    return {
      ...spotlightContentDefaultOptions,
      ...spotlightContentByKey[key],
    };
  });

  return {
    steps,
    handleJoyrideCallback,
    runAllSpotlights,
    stepIndex,
  };
};
